import React from 'react'
import './history.css';
import { Helmet } from 'react-helmet';

function History() {
  const pageTitle = 'Our History-Deliverance Church  Utawala | The Church Of Choice';
  const metaDescription ='In 2009, The Almight God rested faith upon Pastor Wiliam Ouna to begin Deliverance Church Utawala.........'
  return (
    <>
    <Helmet>
      <title>{pageTitle}</title>
      <meta name = "description" content={metaDescription} />
    </Helmet>
     <div className="hero">
      <div className="hero-image">
        <div className="hero-text">
          <h4>About Us</h4>
          <h1>Our History</h1>
        </div>
      </div>
    </div>
    <section className="history">
      <div className="history-context">
        
        <p>Way back on 24thNovember 2009, Deliverance Church Utawala was born with Pastor William Ouna being our founder. At that time, we were located at the shopping centre with a mabati structure and members being around 20. Then our current Senior Pastor Rev Emmanuel Kokonyo moved here around the same time from Athi River.</p>
        <br />
        <p>With God's Grace, we moved to our current location, with is 300m after ACK ST MONICA. Slowly we constructed our beautiful sanctuary with God's faithfullness, trusting in Him. Throughout the years, our church grew to ernomous group till we split into two services. Thirteen years and counting, It has been God going with us.</p>
      </div>
    </section>
    </>
  )
}

export default History